import React, {ChangeEvent, FunctionComponent} from 'react';
import {FormattedMessage} from 'react-intl';
import './styles.scss';

interface IInputCheckbox {
  value: boolean;
  onChange: (value: boolean) => void;
  label: string;
  required?: boolean;
  error?: {id: string; defaultMessage: string} | null;
}

export const InputCheckbox: FunctionComponent<IInputCheckbox> = ({
  value,
  onChange,
  label,
  error,
  required
}: IInputCheckbox) => {
  function handleChangeCheckbox(e: ChangeEvent<HTMLInputElement>) {
    onChange(e.target.checked);
  }

  const id = React.useId();
  const errorId = `${id}-error`;

  return (
    <>
      <div className="input-checkbox">
        <input
          id={id}
          className="input-checkbox__field"
          type="checkbox"
          checked={value}
          onChange={handleChangeCheckbox}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          aria-required={required || undefined}
        />
        <label className="input-checkbox__label" htmlFor={id}>
          {label}
        </label>
      </div>
      <div id={errorId} className="input-checkbox__error">
        {error && <FormattedMessage {...error} />}
      </div>
    </>
  );
};
